var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 7.33331C48.3001 7.33331 51.5833 10.6166 51.5833 14.6666V51.3333C51.5833 55.3834 48.3001 58.6666 44.25 58.6666C40.1999 58.6666 36.9167 55.3834 36.9167 51.3333V14.6666C36.9167 10.6166 40.1999 7.33331 44.25 7.33331Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5833 40.3333C73.5833 36.2832 70.3001 33 66.25 33C62.1999 33 58.9167 36.2832 58.9167 40.3333V51.3333C58.9167 55.3834 62.1999 58.6666 66.25 58.6666C70.3001 58.6666 73.5833 55.3834 73.5833 51.3333V40.3333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 66C12.8916 66 11.25 67.6416 11.25 69.6666C11.25 71.6917 12.8916 73.3333 14.9167 73.3333H73.5833C75.6084 73.3333 77.25 71.6917 77.25 69.6666C77.25 67.6416 75.6084 66 73.5833 66H14.9167Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5833 29.3333C29.5833 25.2832 26.3001 22 22.25 22C18.1999 22 14.9167 25.2832 14.9167 29.3333V51.3333C14.9167 55.3834 18.1999 58.6666 22.25 58.6666C26.3001 58.6666 29.5833 55.3834 29.5833 51.3333V29.3333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.42ebaafc53c8c6a3fa3b3c7876b9582f.svg";
export { ForwardRef as ReactComponent };